import { Box, styled, SxProps, Theme } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import AddButton from 'ui/Buttons/AddButton';

type Props = {
    openModal: () => void;
    sx?: SxProps<Theme>;
};

const StyAddBudgetButton = styled(Box, {
    name: 'StySearchBar',
})(({ theme }) => ({
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexFlow: 'row nowrap',
    borderRadius: '1.25rem',
    height: '2.5rem',
    marginLeft: 'auto',
    backgroundColor: theme.palette.lightGrey,
}));

export default function AddBudgetButton({
    openModal,
    sx = undefined,
}: Props): React.ReactElement {
    const { t } = useTranslation();
    return (
        <StyAddBudgetButton sx={sx}>
            <AddButton
                text={t('adminBudgetSpace.addBudget')}
                onClick={() => openModal()}
            />
        </StyAddBudgetButton>
    );
}
